import { useEffect, useState } from "react";

function normalizePath(path: string): string {
  if (path.length > 1 && path.endsWith("/")) return path.slice(0, -1);
  return path || "/";
}

/**
 * The current URL path. Game pages are real paths (`/pasjans`), not hashes, so the
 * same URLs work behind Apache later. Vite already falls back to index.html.
 */
export function usePathname(): string {
  const [path, setPath] = useState(() => normalizePath(window.location.pathname));

  useEffect(() => {
    const sync = () => setPath(normalizePath(window.location.pathname));
    window.addEventListener("popstate", sync);
    return () => window.removeEventListener("popstate", sync);
  }, []);

  return path;
}
